var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
function useColumnEditField(Component, componentProps) {
    var ResultComponent = React.useMemo(function () {
        var ColumnEditField = function (_a) {
            var error = _a.error, value = _a.value, onChange = _a.onChange;
            var props = __assign({ error: error, value: value || '', onChange: onChange, variant: 'standard' }, (componentProps || {}));
            return React.createElement(Component, __assign({}, props));
        };
        ColumnEditField.displayName = "ColumnEdit".concat(Component.displayName);
        return ColumnEditField;
    }, [Component, componentProps]);
    return ResultComponent;
}
export default useColumnEditField;
